import { DisplayTextOverflowDynamic } from "components/DisplayFields/DisplayTextOverflowDynamic";
import { AuditLogItemModel } from "models/AuditLogItemModel";
import { getResource, isResourceKey } from "providers";

interface AuditLogDetailRowProps {
  keyToUse: string;
  entityName?: string;
  stateLabel?: string;
  items: AuditLogItemModel[];
}

export const AuditLogDetailRow = ({ keyToUse, entityName, stateLabel, items }: AuditLogDetailRowProps) => {
  const rowSpan = items.length;

  return (
    <>
      {items.map((item, ix) => {
        const { propertyName, valueOld, valueNew, state } = item;
        const propertyKey = `${keyToUse}:${propertyName || ix}`;
        const itemStateLabel = isResourceKey(state) ? getResource(state) : state;

        return (
          <tr key={propertyKey} className="no-hover">
            {ix === 0 && (
              <td rowSpan={rowSpan} className="entityName">
                <DisplayTextOverflowDynamic value={entityName} />
              </td>
            )}
            {ix === 0 && (
              <td rowSpan={rowSpan} className="state">
                {stateLabel}
              </td>
            )}
            <td className="propertyName">
              <DisplayTextOverflowDynamic value={propertyName} />
            </td>
            <td className="state">{itemStateLabel}</td>
            <td>
              <del>{valueOld}</del>
            </td>
            <td>
              <ins>{valueNew}</ins>
            </td>
          </tr>
        );
      })}
    </>
  );
};
